import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   Box,
   useColorMode,
} from '@chakra-ui/react';
import { getAccount } from '../../../../../redux/actions/account';
import { useDispatch, useSelector } from 'react-redux';
import {
   addDaybook,
   updateDaybook,
   getDaybook,
   getDaybookForMaster,
   getIssueDaybook,
   getAllDaybooks,
} from '../../../../../redux/actions/daybook';
import {
   EntryFromType,
   LINE_ITEM_REACHED,
   OrderFieldRegion,
   SupplyTypes,
   TDS_APPLY_ON,
   ASK_TO_GENERATE_INVOICE,
} from '../../../../../utils/dropdownEnum';
import { TYPE, SUB_TYPE, METHOD_OF_ROUND_LI_TYPE, AUTO_ROUND_OFF_AT_TYPE, PRINTING_SETTING_TYPE, SAPRATER } from './DaybookTypes';
import { WAREHOUSE_TYPE } from '../../../../../../src/variables/company';
import { renderSwitchControl } from 'utils/DynamicFormData';
import { renderTextareaControl } from 'utils/DynamicFormData';
import { getWarehouse } from '../../../../../redux/actions/warehouse';
import { getGLGroups } from '../../../../../redux/actions/glGroup';
import { getItemGroup } from '../../../../../redux/actions/itemGroup';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal, useUser, useBusinessType } from '../../../../../contexts';

// Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
   type: Yup.mixed()
      .required('Please select a Type')
      .test('not-empty', 'Please select a Type', (val) => val !== '' && val !== null && val !== undefined),
});

const steps = [
   { title: 'Basic', description: 'Set up basic information' },
   { title: 'Settings', description: 'Configure settings' },
   { title: 'Printing', description: 'Choose printing options' },
   { title: 'Others', description: 'Add other details' },
];

const DaybookForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   saveandcontinue = true,
   type,
   search,
   apitype,
   isAbs = false,
}) => {
   const { companyList, userGlobalSettingsData, company: companyDropdown } = useGlobal();
   const { user } = useUser();
   const dbName = companyDropdown?.dbName;
   const [messageFormat, setMessageFormat] = useState('');
   const [error, setError] = useState('');
   const textareaRef = useRef(null);
   const highlightRef = useRef(null);
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const { businessTypes } = useBusinessType();
   const mobile = businessTypes?.businessType?.toUpperCase() === 'MOBILE';
   const Textile = businessTypes?.businessType?.toUpperCase() === 'TEXTILE';
   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const WAREHOUSE_TYPE = [
      { id: 1, name: 'Header', value: 1 },
      { id: 2, name: 'Line-Item', value: 2 },
      ...(mobile ? [{ id: 3, name: 'Line Details', value: 3 }] : []),
   ];

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );
   const [row, setRow] = useState({
      compIds: [],
      //1 Basic
      name: '',
      dueDays: null,
      separator: '',
      prefix: '',
      suffix: '',
      // type: type ? type : TYPE[1].id, //drop
      type: type ? Number(type) : '',
      subType: SUB_TYPE[0].id, //drop
      // entryFormType: 1, //drop - ENUM
      applyGst: false, // Check
      typeOfSupply: SupplyTypes[1].id, //Drop Enum
      isAskTypeOfSupply: false,
      isAllowExchange: false,
      isAllowGstRate: false,
      isOld: false,
      isAllowNotes: false,
      isAllowRemark: false,
      //1 Basic
      // 2 Settings
      accountId: null, //DROP
      itemgroups: [], //Textbox
      // accountGroup: '', //Textbox
      wareHouseId: null, //Drop
      warehouseInId: null, //Drop
      getTransportDetails: false, // Checkbox
      getPaymentDet: false, // Check
      getWorkDetails: false, // Check
      // getOnlinePaymentDetails: false, // Check
      numOfLineItems: 0, // Textbox num
      // actionIfLIReached: LINE_ITEM_REACHED[1].id, // Drop - enum
      // defaultDate: null, //Text date
      forceOrderedDate: null, //TExt Date
      allowZeroAmounts: false, // Check
      allowEditLIAmount: false, // Check
      allowZeroQuantities: false, // Check
      allowIncreaseQty: false, // Check
      allowChangePrice: false, // Check
      autoCallOutAdj: false, // Check
      promptBeforeCallOsa: false, // Check
      orderFieldRegion: null, //Drop - Enum (header , Line Item)
      orderdaybookid: null, //Drop - daybook list
      // issueFieldRegion: null, // Drop - Enum (header , Line Item)
      issuedaybookid: null, //Drop - daybook list
      challanFieldRegion: null, // Drop - Enum (header , Line Item)
      challandaybookid: null, //Drop - daybook list
      getLineDetail: false, // Check
      allowAutoIssue: false, // Check
      // shouldAskSendSMS: false, // Check
      methodOfRoundT: METHOD_OF_ROUND_LI_TYPE[2].id, // Dropdown - Enum
      autoRoundOffAt: AUTO_ROUND_OFF_AT_TYPE[2].id, // Dropdown - Enum
      methodOfRoundLI: METHOD_OF_ROUND_LI_TYPE[1].id, // Dropdown - Enum
      issueDaybookId: null, //Drop - daybook list
      defaultaccountid: null, //Drop - account list
      // 2 Settings
      // 3 Printing
      // titleMessage1: '', //Text
      // titleMessage2: '', //Text
      // headerMessage1: '', //Text
      // headerMessage2: '', //Text
      // footerMessage1: '', //Text
      // footerMessage2: '', //Text
      accDocImgTerms: '', //Text
      accImgTerms: '', //Text
      onlinePrinting: true, //CHeck
      // numOfCopies: 1, //Text num
      askBeforePrint: false, //check
      termsNConditions: '', // Textbox multiline 4
      // 3 Printing
      //4 others
      accountNo: '', //Text
      shortName: '', //Text
      printName: '', //Text
      legalName: '', //Text
      // notes: '', //Text
      // remarks: '', //Text
      customTemp: '', // Textbox multiline 1

      updateRateInItem: false, // Check
      itemWiseLastRate: false, // Check
      partyItemWiseLastRate: false, // Check
      reverseCalcOnItemQty: false, // Check
      accountgroups: [], // Textbox
      TDSApplyOn: 1, // Drop
      purchaseDaybookId: null,
      isGrayPurchase: false,
      isOtherJobWork: false,
      isEnableItemScreen: false,
      isMillIssue: false,
      isMillReceive: false,
      sendWhatsApp: false, // Check
      askToGenerateInvoice: [],
      sendEmail: false, // Check
      emailSettings: 0,
      // askOnlinePaymentDetails: false, // Check
      requireDiscountLineItem: 1, // Text
      isAskToAllow: false,
      askPasswordOnDelete: false,
      isAskIncomeExpenses: false,
      // isNotConsiderInStock: false, // Check

      //4 others
   });
   const [errors, setErrors] = useState({});
   const [activeStep, setActiveStep] = useState(0);
   const [isLoading, setIsLoading] = useState(false);
   const [company, setCompany] = useState(null);
   const applyGST = company?.setting?.applyGST;
   const enablePurchaseOrder = company?.setting?.enablePurchaseOrder;
   const enableSaleOrder = company?.setting?.enableSaleOrder;
   const enableSaleChallan = company?.setting?.enableSaleChallan;
   const enablePurchaseChallan = company?.setting?.enablePurchaseChallan;
   const warehouseWishStock = company?.setting?.warehouseWishStock;
   const toast = useToast();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const dispatch = useDispatch();
   const accountList = useSelector((state) => state.account.list);
   const daybookList = useSelector((state) => state.daybook.issueDaybook);
   const warehouseList = useSelector((state) => state.warehouse.list);
   const daybookData = useSelector((state) => state.daybook?.allDaybooks || []);
   // const companyList = useSelector((state) => state.company.list);
   const glGroupList = useSelector((state) => state.glGroup.list);
   const itemGroupList = useSelector((state) => state.itemGroup.list);

   const shouldSendCompanyidAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;
   const shouldSendCompanyidWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;

   const companyId = localStorage.getItem('companyId');


   const clearFormData = () => {
      setRow({
         //1 Basic
         name: '',
         dueDays: null,
         separator: '',
         prefix: '',
         suffix: '',
         // type: '',
         type: type ? Number(type) : '',
         subType: 0,
         // entryFormType: 1,
         applyGst: false,
         typeOfSupply: null,
         isAskTypeOfSupply: false,
         isAllowExchange: false,
         isAllowGstRate: false,
         isOld: false,
         isAllowNotes: false,
         isAllowRemark: false,
         //1 Basic
         // 2 Settings
         accountId: null,
         itemgroups: [],
         wareHouseId: null,
         warehouseInId: null,
         getTransportDetails: false,
         getPaymentDet: false,
         getWorkDetails: false,
         // getOnlinePaymentDetails: false,
         numOfLineItems: 0,
         // actionIfLIReached: 1,
         // defaultDate: null,
         forceOrderedDate: null,
         allowZeroAmounts: false,
         allowEditLIAmount: false,
         allowZeroQuantities: false,
         allowIncreaseQty: false,
         allowChangePrice: false,
         autoCallOutAdj: false,
         promptBeforeCallOsa: false,
         orderFieldRegion: null,
         orderdaybookid: null,
         // issueFieldRegion: null,
         issuedaybookid: null,
         challanFieldRegion: null,
         challandaybookid: null,
         getLineDetail: false,
         allowAutoIssue: false,
         // shouldAskSendSMS: false,
         methodOfRoundT: null,
         autoRoundOffAt: null,
         methodOfRoundLI: null,
         issueDaybookId: '',
         defaultaccountid: null,
         // 2 Settings
         // 3 Printing
         // titleMessage1: '',
         // titleMessage2: '',
         // headerMessage1: '',
         // headerMessage2: '',
         // footerMessage1: '',
         // footerMessage2: '',
         accDocImgTerms: '',
         accImgTerms: '',
         onlinePrinting: true,
         // numOfCopies: 1,
         printingSettings: 0,
         wpSettings: 0,
         ewayBill: false,
         ewayInvoice: false,
         askBeforePrint: false,
         termsNConditions: '',
         // 3 Printing
         //4 others
         accountNo: '',
         shortName: '',
         printName: '',
         legalName: '',
         // notes: '',
         // remarks: '',
         customTemp: '',
         gstUniqueID: null,
         //4 others
         updateRateInItem: false, // Check
         itemWiseLastRate: false, // Check
         partyItemWiseLastRate: false, // Check
         reverseCalcOnItemQty: false, // Check
         accountgroups: [], // Textbox
         TDSApplyOn: 1, // Drop
         purchaseDaybookId: null,
         isGrayPurchase: false,
         isOtherJobWork: false,
         isEnableItemScreen: false,
         isMillIssue: false,
         isMillReceive: false,
         sendWhatsApp: false, // Check
         askToGenerateInvoice: [],
         // askOnlinePaymentDetails: false, // Check
         requireDiscountLineItem: 1, // Text
         isAskToAllow: false,
         askPasswordOnDelete: false,
         isAskIncomeExpenses: false,
         sendEmail: false, // Check
         emailSettings: 0,
         // isNotConsiderInStock: false, // Check
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         // Only set if not in edit mode and compIds is empty or doesn't include the user's company
         setRow((prev) => {
            if (!prev.compIds || prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
         setRow((prev) => ({
            ...prev,
            type: type ? Number(type) : '',
            name: demoname || '',
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         }));
      } else if (isEditMode && currentRow) {
         setRow({
            //1 Basic
            name: currentRow.name,
            dueDays: currentRow.dueDays,
            separator: (() => {
               const sepObj = SAPRATER.find(
                  (item) => item.name === currentRow.separator ||
                     item.id === currentRow.separator ||
                     item.value === currentRow.separator
               );
               return sepObj ? sepObj.id : currentRow.separator;
            })(),
            prefix: currentRow.prefix || '',
            suffix: currentRow.suffix || '',
            type: currentRow.type || type,
            subType: currentRow.subType,
            accountId: currentRow.accountId,
            // entryFormType: currentRow.entryFormType,
            isAskTypeOfSupply: currentRow.isAskTypeOfSupply,
            isAllowExchange: currentRow.isAllowExchange,
            isAllowGstRate: currentRow.isAllowGstRate,
            isOld: currentRow.isOld,
            isAllowNotes: currentRow.isAllowNotes,
            isAllowRemark: currentRow.isAllowRemark,
            compIds: currentRow?.companyIds || [],
            //1 Basic
            // 2 Settings
            defaultaccountid: currentRow.defaultaccountid || null,
            // itemgroups: currentRow.itemgroups,

            itemgroups: (Array.isArray(itemGroupList) ? itemGroupList : [])
               .map((item) => ({
                  label: item.name,
                  value: item.id,
               }))
               .filter((item) => Array.isArray(currentRow?.itemgroups) && currentRow.itemgroups.includes(item.value)),

            accountgroups: glGroupList
               .map((item) => ({
                  label: item.name,
                  value: item.id,
               }))
               .filter((item) => currentRow.accountgroups?.includes(item.value)),

            wareHouseId: currentRow.wareHouseId,
            warehouseInId: currentRow.warehouseInId,
            getTransportDetails: currentRow.getTransportDetails,
            getPaymentDet: currentRow.getPaymentDet,
            getWorkDetails: currentRow.getWorkDetails,
            // getOnlinePaymentDetails: currentRow.getOnlinePaymentDetails,
            numOfLineItems: currentRow.numOfLineItems || 0,
            // actionIfLIReached: currentRow.actionIfLIReached,
            // defaultDate: currentRow.defaultDate,
            // defaultDate: new Date(currentRow.defaultDate)
            //   .toISOString()
            //   .split('T')[0],
            forceOrderedDate: currentRow.forceOrderedDate,
            // forceOrderedDate: new Date(currentRow.forceOrderedDate)
            //   .toISOString()
            //   .split('T')[0],
            allowZeroAmounts: currentRow.allowZeroAmounts,
            allowEditLIAmount: currentRow.allowEditLIAmount,
            allowZeroQuantities: currentRow.allowZeroQuantities,
            allowIncreaseQty: currentRow.allowIncreaseQty,
            allowChangePrice: currentRow.allowChangePrice,
            autoCallOutAdj: currentRow.autoCallOutAdj,
            promptBeforeCallOsa: currentRow.promptBeforeCallOsa,
            orderFieldRegion: currentRow.orderFieldRegion,
            orderdaybookid: Number(currentRow.orderdaybookid),
            // issueFieldRegion: currentRow.issueFieldRegion,
            issuedaybookid: currentRow.issuedaybookid,
            challanFieldRegion: currentRow.challanFieldRegion,
            challandaybookid: Number(currentRow.challandaybookid),
            getLineDetail: currentRow.getLineDetail,
            allowAutoIssue: currentRow.allowAutoIssue,
            // shouldAskSendSMS: currentRow.shouldAskSendSMS,
            methodOfRoundT: currentRow.methodOfRoundT,
            autoRoundOffAt: currentRow.autoRoundOffAt,
            methodOfRoundLI: currentRow.methodOfRoundLI,
            issueDaybookId: currentRow.issueDaybookId,
            // 2 Settings
            // 3 Printing
            // titleMessage1: currentRow.titleMessage1,
            // titleMessage2: currentRow.titleMessage2,
            // headerMessage1: currentRow.headerMessage1,
            // headerMessage2: currentRow.headerMessage2,
            // footerMessage1: currentRow.footerMessage1,
            // footerMessage2: currentRow.footerMessage2,
            accDocImgTerms: currentRow.accDocImgTerms,
            accImgTerms: currentRow.accImgTerms,
            onlinePrinting: currentRow.onlinePrinting,
            // numOfCopies: currentRow.numOfCopies,
            printingSettings: currentRow.printingSettings,
            wpSettings: currentRow.wpSettings,
            ewayBill: currentRow.ewayBill,
            ewayInvoice: currentRow.ewayInvoice,
            askBeforePrint: currentRow.askBeforePrint,
            termsNConditions: currentRow.termsNConditions,
            // 3 Printing
            // 4 GST Details
            applyGst: currentRow.applyGst,
            gstType: currentRow.gstType,
            gstSubType: currentRow.gstSubType,
            typeOfSupply: currentRow.typeOfSupply,
            customTemp: currentRow.customTemp,
            // 4 GST Details
            //5 others
            accountNo: currentRow.accountNo,
            shortName: currentRow.shortName,
            printName: currentRow.printName,
            legalName: currentRow.legalName,
            // notes: currentRow.notes,
            // remarks: currentRow.remarks,
            gstUniqueID: currentRow.gstUniqueID,
            updateRateInItem: currentRow.updateRateInItem,
            itemWiseLastRate: currentRow.itemWiseLastRate,
            partyItemWiseLastRate: currentRow.partyItemWiseLastRate,
            reverseCalcOnItemQty: currentRow.reverseCalcOnItemQty,
            sendWhatsApp: currentRow.sendWhatsApp,
            TDSApplyOn: currentRow.TDSApplyOn,
            purchaseDaybookId: currentRow.purchaseDaybookId,
            isGrayPurchase: currentRow.isGrayPurchase,
            isOtherJobWork: currentRow.isOtherJobWork,
            isEnableItemScreen: currentRow.isEnableItemScreen ?? false,
            isMillIssue: currentRow.isMillIssue,
            isMillReceive: currentRow.isMillReceive,
            // askOnlinePaymentDetails: currentRow.askOnlinePaymentDetails,
            requireDiscountLineItem: currentRow.requireDiscountLineItem,
            //5 others

            isAskToAllow: currentRow.isAskToAllow,
            askPasswordOnDelete: currentRow.askPasswordOnDelete,
            isAskIncomeExpenses: currentRow.isAskIncomeExpenses,
            sendEmail: currentRow.sendEmail,
            emailSettings: currentRow.emailSettings,
            // isNotConsiderInStock: currentRow.isNotConsiderInStock,

            askToGenerateInvoice: ASK_TO_GENERATE_INVOICE?.map((item) => ({
               label: item.name,
               value: item.value,
            })).filter((item) => currentRow.askToGenerateInvoice?.includes(item.value)),
         });
      }
   }, [isEditMode, currentRow, itemGroupList, glGroupList]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      if (field === 'wareHouseId') {
         setRow((prev) => ({ ...prev, [field]: value === '' ? null : value }));
         setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (newErrors[field]) {
               delete newErrors[field];
            }
            return newErrors;
         });
      } else {
         setRow((prev) => ({ ...prev, [field]: value }));
         setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (newErrors[field]) {
               delete newErrors[field];
            }
            return newErrors;
         });
      }
   };

   const handleSwitchChange = (field) => (event) => {
      setRow((prev) => ({
         ...prev,
         [field]: event.target.checked, // Updates boolean value (true/false)
      }));
   };

   const handleSelectChange = (field, value) => {
      if (field === 'askToGenerateInvoice') {
         if (value?.map((item) => item.value)?.includes(2)) {
            setRow((prev) => ({
               ...prev,
               [field]: value
                  ?.map((item) => {
                     if (item.value === 2) return item;
                     return null;
                  })
                  ?.filter((x) => x !== null),
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               [field]: value
                  ?.map((item) => {
                     if ([0, 1]?.includes(item.value)) return item;
                     return null;
                  })
                  ?.filter((x) => x !== null),
            }));
         }
      }
      if (['itemgroups', 'accountgroups']?.includes(field)) {
         setRow((prev) => ({
            ...prev,
            [field]: [value],
         }));
      }
   };

   const onFormSubmit = async () => {
      try {
         setIsLoading(true);
         const separatorObj = SAPRATER.find((item) => item.id === row.separator || item.value === row.separator);
         const separator = separatorObj ? separatorObj.name : '';
         const processedData = {
            ...row,
            separator: separator,
            type: Number(row.type),
            compIds: row.compIds,
            subType: Number(row.subType),
            challandaybookid: row.challandaybookid ? row.challandaybookid.toString() : null,
            // askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item.value) ?? []),
            askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item) ?? []),
            // itemgroups: row.itemgroups?.map((item) => Number(item.value) ?? []),
            itemgroups: row.itemgroups?.map((item) => Number(item) ?? []),
            // accountgroups: row.accountgroups?.map((item) => Number(item.value) ?? []),
            accountgroups: row.accountgroups?.map((item) => Number(item) ?? []),
            customTemp: row.customTemp || '',
            isAskTypeOfSupply: row.isAskTypeOfSupply,
            isAllowExchange: row.isAllowExchange,
            isAllowGstRate: row.isAllowGstRate,
            isOld: row.isOld,
            isAllowNotes: row.isAllowNotes,
            isAllowRemark: row.isAllowRemark,
            isGrayPurchase: row.isGrayPurchase,
            isOtherJobWork: row.isOtherJobWork,
            isEnableItemScreen: row.isEnableItemScreen,
            isMillIssue: row.isMillIssue,
            isMillReceive: row.isMillReceive,
            issuedaybookid: row.issuedaybookid || null,
            isAskToAllow: row.isAskToAllow,
            askPasswordOnDelete: row.askPasswordOnDelete,
            isAskIncomeExpenses: row.isAskIncomeExpenses,
            // isNotConsiderInStock: row.isNotConsiderInStock,
            requireDiscountLineItem: Number(row.requireDiscountLineItem),
            purchaseDaybookId: (row.type === 5 || row.type === 19) ? row.purchaseDaybookId !== '' ? row.purchaseDaybookId : null : null,
            orderdaybookid: Number(row.purchaseDaybookId) || null,
            orderFieldRegion: row.orderFieldRegion !== '' ? row.orderFieldRegion : null,
            challanFieldRegion: row.challanFieldRegion !== '' ? row.challanFieldRegion : null,
            prefix: (() => {
               if (!row.prefix || !separator) return row.prefix || '';
               const escaped = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
               return row.prefix.replace(new RegExp(escaped, 'g'), '');
            })(),
            suffix: (() => {
               if (!row.suffix || !separator) return row.suffix || '';
               const escaped = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
               return row.suffix.replace(new RegExp(escaped, 'g'), '');
            })(),
         };

         if (isEditMode && currentRow?.id) {
            processedData.id = currentRow.id;
            await dispatch(updateDaybook(processedData));
         } else {
            await dispatch(addDaybook(processedData));
         }
         // await dispatch(
         //    getDaybook({
         //       companyId: Number(user?.loginhistory?.companyId),
         //       page: 1,
         //       limit: 10,
         //       sortBy: 'id',
         //       sortOrder: 'desc',
         //    }),
         // );
         await dispatch(getDaybookForMaster({ companyId: Number(user?.loginhistory?.companyId) }));
         await dispatch(getDaybook({ companyId: Number(user?.loginhistory?.companyId) }));
         clearFormData();
         setActiveStep(0);
         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Daybook.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      try {
         setIsLoading(true);
         const separatorObj = SAPRATER.find((item) => item.id === row.separator || item.value === row.separator);
         const separator = separatorObj ? separatorObj.name : '';
         const processedData = {
            ...row,
            separator: separator,
            type: Number(row.type),
            subType: Number(row.subType),
            challandaybookid: row.challandaybookid ? row.challandaybookid.toString() : null,
            // askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item.value) ?? []),
            askToGenerateInvoice: row.askToGenerateInvoice?.map((item) => Number(item) ?? []),
            // itemgroups: row.itemgroups?.map((item) => Number(item.value) ?? []),
            itemgroups: row.itemgroups?.map((item) => Number(item) ?? []),
            // accountgroups: row.accountgroups?.map((item) => Number(item.value) ?? []),
            accountgroups: row.accountgroups?.map((item) => Number(item) ?? []),
            isAskTypeOfSupply: row.isAskTypeOfSupply,
            isAllowExchange: row.isAllowExchange,
            isAllowGstRate: row.isAllowGstRate,
            isOld: row.isOld,
            isAllowNotes: row.isAllowNotes,
            isAllowRemark: row.isAllowRemark,
            isAskToAllow: row.isAskToAllow,
            isEnableItemScreen: row.isEnableItemScreen,
            askPasswordOnDelete: row.askPasswordOnDelete,
            isAskIncomeExpenses: row.isAskIncomeExpenses,
            // isNotConsiderInStock: row.isNotConsiderInStock,
            requireDiscountLineItem: Number(row.requireDiscountLineItem),
            orderFieldRegion: row.orderFieldRegion !== '' ? row.orderFieldRegion : null,
            challanFieldRegion: row.challanFieldRegion !== '' ? row.challanFieldRegion : null,
            prefix: (() => {
               if (!currentRow.prefix) return '';
               const sepObj = SAPRATER.find(
                  (item) => item.name === currentRow.separator ||
                     item.id === currentRow.separator ||
                     item.value === currentRow.separator
               );
               const sep = sepObj ? sepObj.name : '';
               if (!sep) return currentRow.prefix;
               const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
               return currentRow.prefix.replace(new RegExp(escaped, 'g'), '');
            })(),
            suffix: (() => {
               if (!currentRow.suffix) return '';
               const sepObj = SAPRATER.find(
                  (item) => item.name === currentRow.separator ||
                     item.id === currentRow.separator ||
                     item.value === currentRow.separator
               );
               const sep = sepObj ? sepObj.name : '';
               if (!sep) return currentRow.suffix;
               const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
               return currentRow.suffix.replace(new RegExp(escaped, 'g'), '');
            })(),
         };

         if (isEditMode && currentRow?.id) {
            processedData.id = currentRow.id;
            dispatch(updateDaybook(processedData));
         } else {
            dispatch(addDaybook(processedData));
         }
         // dispatch(
         //    getDaybook({
         //       companyId: user?.loginhistory?.companyId,
         //       page: 1,
         //       limit: 10,
         //       sortBy: 'id',
         //       sortOrder: 'desc',
         //    }),
         // );
         clearFormData();
         setActiveStep(0);
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Daybook.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleNext = async () => {
      const isValid = await validateStep();
      if (isValid) {
         if (activeStep < steps.length - 1) {
            setActiveStep(activeStep + 1);
         } else {
            onFormSubmit();
         }
      } else {
         if (errors.name || errors.type) {
            setActiveStep(0);
         }
         toast({
            title: 'Validation Error',
            description: errors.type
               ? 'Please select a Type before continuing.'
               : errors.name
                  ? 'Please enter a Name before continuing.'
                  : 'Please correct the errors.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' || // for react-select input
            activeElement?.isContentEditable;

         if (isTyping) return; // Don't trigger shortcuts while typing

         if (isOpen && e.key.toLowerCase() === 's') {
            // e.preventDefault(); // prevent browser default (e.g. save page)

            if (e.shiftKey) {
               handlesavecontinue(); // SHIFT + S
            } else {
               handleSave(); // S only
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            handleCansel();
         }
         if (isOpen && e.key.toLowerCase() === 'n') {
            handleNext();
         }
         if (isOpen && e.key === 'Escape') {
            e.stopPropagation(); // Prevent event from bubbling to parent
            onClose();
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   const handleSave = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               typeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               subtypeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               typeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         } else if (!row.glGroupId || row.glGroupId === '') {
            setActiveStep(0);

            setTimeout(() => {
               subtypeRef.current?.focus(); // ✅ Focus dropdown
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlePrevious = () => {
      if (activeStep > 0) {
         setActiveStep(activeStep - 1);
      }
   };

   useEffect(() => {
      if (isOpen) {
         dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(getWarehouse({ ...(shouldSendCompanyidWarehouse && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(
            getIssueDaybook({
               type: 19,
               ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
               companyId: user?.loginhistory?.companyId,
            }),
         );
         dispatch(
            getAllDaybooks({
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(getItemGroup({ ...(shouldSendCompanyidItemGroup && { companyIds: user?.loginhistory?.companyId }) }));
         dispatch(getGLGroups());
         // dispatch(getCompanies());
      }
   }, [dispatch, isOpen]);

   useEffect(() => {
      if (companyList.length > 0 && companyId) {
         const company = companyList.find((company) => company.id.toString() === companyId.toString());
         setCompany(company);
      }
   }, [companyList, companyId]);

   const itemgroupsoptions = (Array.isArray(itemGroupList) ? itemGroupList : []).map((item) => ({
      label: item.name,
      value: item.id,
      name: item.name,
      id: item.id,
   }));

   const accountgroupsoptions = (Array.isArray(glGroupList) ? glGroupList : []).map((item) => ({
      label: item.name,
      value: item.id,
      name: item.name,
      id: item.id,
   }));
   const ASK_TO_GENERATE_INVOICE_option = ASK_TO_GENERATE_INVOICE?.map((item) => ({
      label: item.name,
      value: item.id,
      name: item.name,
      id: item.id,
   }));

   // options={glGroupList?.map((item) => ({
   //    label: item.name,
   //    value: item.id,
   // }))}

   const nameInputRef = useRef();
   const typeRef = useRef();
   const subtypeRef = useRef();
   const entryFormTypeRef = useRef();
   const typeOfSupplyRef = useRef();
   const applyGstRef = useRef();
   const accountRef = useRef();
   const isAskTypeOfSupplyRef = useRef();
   const companyRef = useRef();
   const isAllowExchangeRef = useRef();
   const isAllowGstRateRef = useRef();
   const savefinish = useRef();
   const accountgroupsRef = useRef();
   const defaultaccountRef = useRef();
   const itemgroupsRef = useRef();
   // const defaultDateRef = useRef();
   // const actionIfLIReachedRef = useRef();
   const getWorkDetailsRef = useRef();
   // const getOnlinePaymentDetailsRef = useRef();
   const numOfLineItemsRef = useRef();
   const getPaymentDetRef = useRef();
   const getTransportDetailsRef = useRef();
   const wareHouseRef = useRef();
   const wareHouseInRef = useRef();
   // const shouldAskSendSMSRef = useRef();
   const challandaybookRef = useRef();
   const getLineDetailRef = useRef();
   const allowAutoIssueRef = useRef();
   const challanFieldRegionRef = useRef();
   const issuedaybookRef = useRef();
   // const issueFieldRegionRef = useRef();
   const promptBeforeCallOsaRef = useRef();
   const orderFieldRegionRef = useRef();
   const orderdaybookRef = useRef();
   const allowIncreaseQtyRef = useRef();
   const allowChangePriceRef = useRef();
   const autoCallOutAdjRef = useRef();
   const allowZeroAmountsRef = useRef();
   const allowEditLIAmountRef = useRef();
   const allowZeroQuantitiesRef = useRef();
   const forceOrderedDateRef = useRef();
   const isAskToAllowRef = useRef();
   const askPasswordOnDeleteRef = useRef();
   const isAskIncomeExpensesRef = useRef();
   const dueDaysInputRef = useRef();
   // const isNotConsiderInStockRef = useRef();
   const methodOfRoundLIRef = useRef();
   const autoRoundOffAtRef = useRef();
   const requireDiscountLineItemRef = useRef();
   const methodOfRoundTRef = useRef();
   // const titleMessage1Ref = useRef();
   // const footerMessage1Ref = useRef();
   // const headerMessage2Ref = useRef();
   // const headerMessage1Ref = useRef();
   // const titleMessage2Ref = useRef();
   const termsNConditionsRef = useRef();
   const wpSettingsRef = useRef();
   const sendWhatsAppRef = useRef();
   const ewayInvoiceRef = useRef();
   const printingSettingsRef = useRef();
   const accImgTermsRef = useRef();
   const accDocImgTermsRef = useRef();
   const ewayBillRef = useRef();
   const onlinePrintingRef = useRef();
   // const numOfCopiesRef = useRef();
   const askBeforePrintRef = useRef();
   // const footerMessage2Ref = useRef();
   const isOldRef = useRef();
   const isAllowNotesRef = useRef();
   const isAllowRemarkRef = useRef();
   // const askOnlinePaymentDetailsRef = useRef();
   const reverseCalcOnItemQtyRef = useRef();
   const TDSApplyOnRef = useRef();
   const purcherDaybookRef = useRef();
   const isGrayPurchaseRef = useRef();
   const isMillIssueRef = useRef();
   const isMillReceiveRef = useRef();
   const isOtherJobWorkRef = useRef();
   const isEnableItemScreenRef = useRef();
   const askToGenerateInvoiceRef = useRef();
   const updateRateInItemRef = useRef();
   const itemWiseLastRateRef = useRef();
   const partyItemWiseLastRateRef = useRef();
   // const remarksRef = useRef();
   const legalNameRef = useRef();
   // const notesRef = useRef();
   const accountNoRef = useRef();
   const shortNameRef = useRef();
   const printNameRef = useRef();
   // const notesRef = useRef();
   const prefixRef = useRef();
   const suffixRef = useRef();
   const separatorRef = useRef();
   const sendEmailRef = useRef();
   const emailSettingsRef = useRef();

   const handleCansel = useCallback(async () => {
      onClose();
      if (!isEditMode) {
         clearFormData();
      }
      await dispatch(getAllDaybooks({ companyId: Number(user?.loginhistory?.companyId) }));
   });

   // useEffect(() => {
   //    // ✅ Jab modal open ho aur demoname ho to name set karo
   //    if (isOpen && demoname && !isEditMode) {
   //       setRow((prev) => ({
   //          ...prev,
   //          name: demoname,
   //       }));
   //    }
   // }, [isOpen, demoname]); // ✅ isEditMode dependency mat daalo

   // useEffect(() => {
   //    if (demoname && row.name === '') {
   //       // setRow((prev) => ({ ...prev, name: demoname }));
   //       handleInputChange('name', demoname);
   //    }
   //    demoname = '';
   // }, [demoname, row.name]);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isOpen]);

   useEffect(() => {
      if (activeStep === 1) {
         setTimeout(() => {
            defaultaccountRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 2) {
         setTimeout(() => {
            askBeforePrintRef.current?.focus();
            // titleMessage1Ref.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 3) {
         setTimeout(() => {
            if (['Bank'].includes(row.typeName)) {
               accountNoRef.current?.focus();
            } else {
               shortNameRef.current?.focus();
            }
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape' && isOpen) {
            e.preventDefault();
            handleCansel();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleCansel, isOpen]);

   const handleFocusMove = (e, nextRef, prevRef) => {
      if (e.key === 'Tab' || e.key === 'Enter') {
         e.preventDefault(); // Prevent default tab/enter behavior
         if (e.shiftKey) {
            // Move to previous input if Shift is pressed
            prevRef?.current?.focus();
         } else {
            // Move to next input
            nextRef?.current?.focus();
         }
      }
   };

   const insertKeyIntoMessage = (key) => {
      const textarea = textareaRef.current;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = row.customTemp || '';
      const before = text.substring(0, start);
      const after = text.substring(end);

      const newText = before + `{${key}}` + after;

      // Update both messageFormat state and row.customTemp
      setMessageFormat(newText);
      setRow((prev) => ({ ...prev, customTemp: newText }));

      // Set cursor position after inserted key
      setTimeout(() => {
         textarea.focus();
         textarea.setSelectionRange(start + key.length + 2, start + key.length + 2);
      }, 0);
   };
   const handleCustomTempChange = (e) => {
      const value = e.target.value;
      setMessageFormat(value);
      setRow((prev) => ({ ...prev, customTemp: value }));
   };

   const renderColoredText = (text) => {
      if (!text) return null;

      const parts = text.split(/(\{[^}]+\})/g);
      return parts.map((part, index) => {
         if (part.match(/\{[^}]+\}/)) {
            return (
               <span key={index} style={{ color: '#2563eb', fontWeight: '600' }}>
                  {part}
               </span>
            );
         }
         return <span key={index}>{part}</span>;
      });
   };

   const getHighlightedText = (text) => {
      if (!text) return '';
      // Replace variables with colored HTML
      return text.replace(
         /\{([^}]+)\}/g,
         '<span style="background-color: #dbeafe; color: #1e40af; font-weight: 600; padding: 0 4px; border-radius: 3px;">&#123;$1&#125;</span>',
      );
   };

   // Add scroll sync handler
   const handleTextareaScroll = (e) => {
      if (highlightRef.current) {
         highlightRef.current.scrollTop = e.target.scrollTop;
         highlightRef.current.scrollLeft = e.target.scrollLeft;
      }
   };

   const insertDemoFormat = (format) => {
      // Update the row.customTemp with new format
      handleCustomTempChange({ target: { value: format } });

      // Reset scroll position
      setTimeout(() => {
         if (textareaRef.current) {
            textareaRef.current.scrollTop = 0;
         }
         if (highlightRef.current) {
            highlightRef.current.scrollTop = 0;
         }
      }, 0);
   };

   return (
      <Modal isOpen={isOpen} onClose={handleCansel} size="6xl" scrollBehavior="inside">
         <ModalOverlay bg={isDark ? 'blackAlpha.700' : 'blackAlpha.500'} backdropFilter="blur(4px)" />
         <ModalContent
            bg={isDark ? 'gray.800' : 'white'}
            p={0}
            mx="15px"
            mt={{ base: '20px', md: '40px', xl: '60px' }}
            mb={{ base: '20px', md: '40px', xl: '60px' }}
            maxH="calc(100vh - 120px)"
            boxShadow={isDark ? '0 25px 50px -12px rgba(0, 0, 0, 0.5)' : '0 25px 50px -12px rgba(0, 0, 0, 0.25)'}
            border={isDark ? '1px solid' : 'none'}
            borderColor={isDark ? 'gray.700' : 'transparent'}
            display="flex"
            flexDirection="column">
            {/* Header with gradient - Fixed */}
            <ModalHeader
               className={`relative rounded-t-md overflow-hidden ${isDark
                  ? 'bg-gradient-to-r from-blue-900/80 via-purple-900/80 to-indigo-900/80 border-b border-blue-700/50'
                  : 'bg-gradient-to-r from-blue-50 via-purple-50 to-indigo-50 border-b border-blue-200'
                  }`}
               fontSize="22px"
               fontWeight="800"
               py={4}
               px={6}
               flexShrink={0}>
               <div className="flex items-center gap-3">
                  <div
                     className={`p-1 rounded-xl ${isDark ? 'bg-blue-600/20 border border-blue-500/30' : 'bg-blue-100 border border-blue-200'
                        }`}>
                     {isEditMode ? '✏️' : '✨'}
                  </div>
                  <span
                     className={`bg-gradient-to-r ${isDark ? 'from-blue-200 to-purple-200' : 'from-blue-600 to-purple-600'
                        } bg-clip-text text-transparent`}>
                     {isEditMode ? 'Edit Daybook' : 'Add New Daybook'}
                  </span>
               </div>
               <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-cyan-500"></div>
            </ModalHeader>

            <ModalCloseButton
               className={`absolute top-4 right-6 ${isDark
                  ? 'text-gray-300 hover:text-white hover:bg-red-600/20 border border-gray-600'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-red-100 border border-gray-300'
                  } transition-all duration-200 rounded-xl w-8 h-8`}
               _focus={{ boxShadow: 'none' }}
            />

            {/* Scrollable Body */}
            <ModalBody p={3} overflow="auto" flex="1">
               <Grid h="auto" templateColumns="repeat(1, 1fr)" gap={4}>
                  {/* Stepper Section - Fixed at top of scroll area */}
                  <div
                     className={`
                  ${isDark ? 'bg-gray-800 border-gray-600' : 'bg-gray-50 border-gray-300'} 
                  rounded-xl p-5 mb-6 shadow-sm border-2
               `}>
                     <div className="flex items-center justify-between">
                        {steps.map((step, index) => (
                           <div key={index} className="flex items-center flex-1">
                              <div className="flex flex-col items-center flex-1">
                                 <button
                                    onClick={() => setActiveStep(index)}
                                    className={`transition-all duration-300 hover:scale-105 ${activeStep === index ? 'transform scale-110' : ''
                                       }`}>
                                    <div
                                       className={`
                                    w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all duration-300
                                    ${activeStep === index
                                             ? isDark
                                                ? 'bg-purple-600 border-purple-500'
                                                : 'bg-blue-500 border-blue-400'
                                             : isDark
                                                ? 'border-gray-500'
                                                : 'border-gray-400'
                                          }
                                    ${activeStep > index
                                             ? isDark
                                                ? 'bg-green-600 border-green-500'
                                                : 'bg-green-500 border-green-400'
                                             : ''
                                          }
                                 `}>
                                       {activeStep > index ? (
                                          <span className="text-white">✓</span>
                                       ) : (
                                          <span
                                             className={`
                                          ${activeStep === index
                                                   ? 'text-white'
                                                   : isDark
                                                      ? 'text-gray-300'
                                                      : 'text-gray-600'
                                                }
                                       `}>
                                             {index + 1}
                                          </span>
                                       )}
                                    </div>
                                 </button>
                                 <span
                                    className={`
                                 text-xs font-semibold mt-2 text-center
                                 ${isDark ? 'text-gray-300' : 'text-gray-700'}
                              `}>
                                    {step.title}
                                 </span>
                              </div>
                              {index < steps.length - 1 && (
                                 <div
                                    className={`
                                 flex-1 h-0.5 mx-4
                                 ${isDark ? 'bg-gray-600' : 'bg-gray-300'}
                              `}
                                 />
                              )}
                           </div>
                        ))}
                     </div>
                  </div>

                  {/* Form Section */}
                  <GridItem>
                     <Box
                        bg={isDark ? 'gray.900' : 'white'}
                        border="1px solid"
                        borderColor={isDark ? 'gray.700' : 'gray.200'}
                        borderRadius="16px"
                        p={6}
                        boxShadow={isDark ? '0 4px 6px -1px rgba(0, 0, 0, 0.3)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'}>
                        <Grid
                           templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' }}
                           gap={5}>
                           {activeStep === 0 && (
                              <>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'name',
                                       'Name',
                                       {
                                          value: row.name,
                                          onChange: (e) => handleInputChange('name', e.target.value),
                                          disabled: isEditMode && isAbs,
                                          ref: nameInputRef,
                                          // onKeyDown: (e) => {
                                          //    if (e.key === 'Enter' || e.key === 'Tab') {
                                          //       e.preventDefault();
                                          //       typeRef.current?.focus();
                                          //    }
                                          // },
                                          onKeyDown: (e) => handleFocusMove(e, typeRef, null),
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       true,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'type',
                                       'Type',
                                       TYPE,
                                       {
                                          value: row.type !== '' ? Number(row.type) : '',
                                          onChange: (value) => {
                                             const selectedOption = TYPE?.find(
                                                (item) => item.value === value || item.id === value,
                                             );
                                             handleInputChange('type', value);
                                             if (selectedOption) {
                                                handleInputChange(
                                                   'typeName',
                                                   selectedOption.name || selectedOption.label,
                                                );
                                             }
                                          },
                                          disabled: isEditMode && isAbs,
                                          ref: typeRef,
                                          nextRef: Textile
                                             ? subtypeRef
                                             : ![
                                                'Cash',
                                                'Bank',
                                                'Debit Note',
                                                'Credit Note',
                                                'Journal Voucher',
                                             ].includes(row.typeName)
                                                ? entryFormTypeRef
                                                : company && company?.gstRegNo
                                                   ? applyGstRef
                                                   : accountRef,
                                       },
                                       errors,
                                       textColor,
                                       true,
                                       'Select Type',
                                    )}
                                 </GridItem>
                                 {Textile && (
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'subType',
                                          'Sub Type',
                                          SUB_TYPE,
                                          {
                                             value: row.subType,
                                             onChange: (value) => {
                                                handleInputChange('subType', value);
                                             },
                                             ref: subtypeRef,
                                             nextRef: ![
                                                'Cash',
                                                'Bank',
                                                'Debit Note',
                                                'Credit Note',
                                                'Journal Voucher',
                                             ].includes(row.typeName)
                                                ? typeOfSupplyRef
                                                : company && company?.gstRegNo
                                                   ? applyGstRef
                                                   : accountRef,
                                          },
                                          errors,
                                          textColor,
                                          true,
                                          'Select Sub type',
                                       )}
                                    </GridItem>
                                 )}
                                 {!['Cash', 'Bank', 'Debit Note', 'Credit Note', 'Journal Voucher'].includes(
                                    row.typeName,
                                 ) && (
                                       <>
                                          {/* <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'entryFormType',
                                                'Form Type',
                                                EntryFromType,
                                                {
                                                   value: row.entryFormType || EntryFromType[0].id,
                                                   onChange: (value) => handleInputChange('entryFormType', value),
                                                   ref: entryFormTypeRef,
                                                   nextRef: typeOfSupplyRef,
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Form Type',
                                             )}
                                          </GridItem> */}
                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'typeOfSupply',
                                                'Supply Type',
                                                SupplyTypes,
                                                {
                                                   value: row.typeOfSupply || SupplyTypes[1].id,
                                                   onChange: (value) => handleInputChange('typeOfSupply', value),
                                                   ref: typeOfSupplyRef,
                                                   nextRef: company && company?.gstRegNo ? applyGstRef : accountRef,
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Type of Supply',
                                             )}
                                          </GridItem>
                                       </>
                                    )}
                                 {company && company?.gstRegNo && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'applyGst',
                                          'Apply GST',
                                          {
                                             isChecked: row.applyGst,
                                             onChange: handleSwitchChange('applyGst'),
                                             ref: applyGstRef,
                                             // onKeyDown: (e) => {
                                             //    if (e.key === 'Enter' || e.key === 'Tab') {
                                             //       e.preventDefault();
                                             //       accountRef.current?.focus();
                                             //    }
                                             // },
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   accountRef,
                                                   ![
                                                      'Cash',
                                                      'Bank',
                                                      'Debit Note',
                                                      'Credit Note',
                                                      'Journal Voucher',
                                                   ].includes(row.typeName)
                                                      ? typeOfSupplyRef
                                                      : Textile
                                                         ? subtypeRef
                                                         : typeRef,
                                                ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'accountId',
                                       'Account',
                                       accountList,
                                       {
                                          value: row.accountId,
                                          onChange: (value) => handleInputChange('accountId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                          ref: accountRef,
                                          // onKeyDown: (e) => {
                                          //    if (e.key === 'Enter' || e.key === 'Tab') {
                                          //       e.preventDefault();
                                          //       isAskTypeOfSupplyRef.current?.focus();
                                          //    }
                                          // },
                                          onKeyDown: (e) =>
                                             handleFocusMove(
                                                e,
                                                isAskTypeOfSupplyRef,
                                                company && company?.gstRegNo
                                                   ? applyGstRef
                                                   : ![
                                                      'Cash',
                                                      'Bank',
                                                      'Debit Note',
                                                      'Credit Note',
                                                      'Journal Voucher',
                                                   ].includes(row.typeName)
                                                      ? entryFormTypeRef
                                                      : Textile
                                                         ? subtypeRef
                                                         : typeRef,
                                             ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Account',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAskTypeOfSupply',
                                       'Ask Type Of Supply',
                                       {
                                          isChecked: row.isAskTypeOfSupply,
                                          onChange: handleSwitchChange('isAskTypeOfSupply'),
                                          ref: isAskTypeOfSupplyRef,
                                          // onKeyDown: (e) => {
                                          //    if (e.key === 'Enter' || e.key === 'Tab') {
                                          //       e.preventDefault();
                                          //       isAllowExchangeRef.current?.focus();
                                          //    }
                                          // },
                                          onKeyDown: (e) =>
                                             handleFocusMove(
                                                e,
                                                shouldSendCompanyidDaybook
                                                   ? companyRef
                                                   : mobile
                                                      ? isAllowExchangeRef
                                                      : savefinish,
                                                accountRef,
                                             ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {shouldSendCompanyidDaybook && (
                                    <GridItem className="seperator-width">
                                       {renderDynamicUiDropdown(
                                          'company',
                                          'Company',
                                          lastcompanyOptions,
                                          {
                                             value: row.compIds,
                                             onChange: handleCompanyChange,
                                             ref: companyRef,
                                             nextRef: mobile ? isAllowExchangeRef : savefinish,
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   mobile ? isAllowExchangeRef : savefinish,
                                                   isAskTypeOfSupplyRef,
                                                ),
                                          },
                                          {},
                                          textColor,
                                          false,
                                          'Select company',
                                          true,
                                          undefined,
                                          true,
                                       )}
                                    </GridItem>
                                 )}
                                 {mobile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isAllowExchange',
                                          'Ask Allow Of Exchange',
                                          {
                                             isChecked: row.isAllowExchange,
                                             onChange: handleSwitchChange('isAllowExchange'),
                                             ref: isAllowExchangeRef,
                                             // onKeyDown: (e) => {
                                             //    if (e.key === 'Enter' || e.key === 'Tab') {
                                             //       e.preventDefault();
                                             //       savefinish.current?.focus();
                                             //    }
                                             // },
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   isAllowGstRateRef,
                                                   shouldSendCompanyidDaybook ? companyRef : isAskTypeOfSupplyRef,
                                                ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {company && company?.gstRegNo && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isAllowGstRate ',
                                          'Ask Allow Gst Rate',
                                          {
                                             isChecked: row.isAllowGstRate,
                                             onChange: handleSwitchChange('isAllowGstRate'),
                                             ref: isAllowGstRateRef,
                                             onKeyDown: (e) =>
                                                handleFocusMove(
                                                   e,
                                                   savefinish,
                                                   mobile
                                                      ? isAllowExchangeRef
                                                      : shouldSendCompanyidDaybook
                                                         ? companyRef
                                                         : isAskTypeOfSupplyRef,
                                                ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                              </>
                           )}
                           {activeStep === 1 && (
                              <>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'defaultaccountid',
                                       'Default Account',
                                       accountList,
                                       {
                                          value: row.defaultaccountid,
                                          onChange: (value) => handleInputChange('defaultaccountid', value),
                                          ref: defaultaccountRef,
                                          onKeyDown: (e) => handleFocusMove(e, itemgroupsRef, null),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Default Account',
                                    )}
                                 </GridItem>
                                 <GridItem>
                                    {renderDynamicDropdown(
                                       'itemgroups',
                                       'Item Groups',
                                       itemgroupsoptions,
                                       {
                                          value: row.itemgroups,
                                          onChange: (e) => handleSelectChange('itemgroups', e),
                                          showCustomNoOptions: true,
                                          openfrom: 'itemgroups',
                                          ref: itemgroupsRef,
                                          onKeyDown: (e) => handleFocusMove(e, accountgroupsRef, defaultaccountRef),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Default Account',
                                    )}
                                 </GridItem>

                                 <GridItem>
                                    {renderDynamicDropdown(
                                       'accountgroups',
                                       'Account Groups',
                                       accountgroupsoptions,
                                       {
                                          value: row.accountgroups,
                                          onChange: (e) => handleSelectChange('accountgroups', e),
                                          showCustomNoOptions: true,
                                          openfrom: 'ledger',
                                          ref: accountgroupsRef,
                                          onKeyDown: (e) => handleFocusMove(e, warehouseWishStock ? wareHouseRef : getTransportDetailsRef, itemgroupsRef),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Default Account',
                                    )}
                                 </GridItem>

                                 {warehouseWishStock && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {/* change */}
                                          {renderDynamicDropdown(
                                             'wareHouseId',
                                             'Ware House',
                                             warehouseList,
                                             {
                                                value: row.wareHouseId,
                                                onChange: (value) => handleInputChange('wareHouseId', value),
                                                showCustomNoOptions: true,
                                                openfrom: 'wareHouse',
                                                ref: wareHouseRef,
                                                onKeyDown: (e) => handleFocusMove(e, wareHouseInRef, accountgroupsRef),

                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Ware House',
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {/* change */}
                                          {renderDynamicDropdown(
                                             'warehouseInId',
                                             'Ware House in',
                                             WAREHOUSE_TYPE,
                                             {
                                                value: row.warehouseInId,
                                                onChange: (value) => handleInputChange('warehouseInId', value),
                                                ref: wareHouseInRef,
                                                onKeyDown: (e) => handleFocusMove(e, getTransportDetailsRef, wareHouseRef),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Ware House',
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'getTransportDetails',
                                       'Transport Details',
                                       {
                                          isChecked: row.getTransportDetails,
                                          onChange: handleSwitchChange('getTransportDetails'),
                                          ref: getTransportDetailsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             Textile ? getTransportDetailsRef : allowZeroAmountsRef,
                                             warehouseWishStock ? wareHouseInRef : accountgroupsRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {Textile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'getWorkDetails',
                                          'Get Work Details',
                                          {
                                             isChecked: row.getWorkDetails,
                                             onChange: handleSwitchChange('getWorkDetails'),
                                             ref: getWorkDetailsRef,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                allowZeroAmountsRef,
                                                getTransportDetailsRef
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {/* <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'getOnlinePaymentDetails',
                                       'Get Online Payment Details',
                                       {
                                          isChecked: row.getOnlinePaymentDetails,
                                          onChange: handleSwitchChange('getOnlinePaymentDetails'),
                                          ref: getOnlinePaymentDetailsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                numOfLineItemsRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem> */}
                                 {/* <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'actionIfLIReached',
                                       'Action If LI Reached',
                                       LINE_ITEM_REACHED,
                                       {
                                          value: row.actionIfLIReached,
                                          onChange: (value) => handleInputChange('actionIfLIReached', value),
                                          ref: actionIfLIReachedRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                // defaultDateRef.current?.focus();
                                                forceOrderedDateRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Action If LI Reached',
                                    )}
                                 </GridItem> */}
                                 {/* <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'defaultDate',
                                       'Default Date',
                                       {
                                          value: row.defaultDate,
                                          onChange: (e) => handleInputChange('defaultDate', e.target.value),
                                          ref: defaultDateRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                forceOrderedDateRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'date',
                                       false,
                                    )}
                                 </GridItem> */}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'allowZeroAmounts',
                                       'Allow Zero Amounts',
                                       {
                                          isChecked: row.allowZeroAmounts,
                                          onChange: handleSwitchChange('allowZeroAmounts'),
                                          ref: allowZeroAmountsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             allowEditLIAmountRef,
                                             Textile ? getWorkDetailsRef : getTransportDetailsRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'allowEditLIAmount',
                                       'Allow Edit LI Amounts',
                                       {
                                          isChecked: row.allowEditLIAmount,
                                          onChange: handleSwitchChange('allowEditLIAmount'),
                                          ref: allowEditLIAmountRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             allowZeroQuantitiesRef,
                                             allowZeroAmountsRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'allowZeroQuantities',
                                       'Allow Zero Quantity',
                                       {
                                          isChecked: row.allowZeroQuantities,
                                          onChange: handleSwitchChange('allowZeroQuantities'),
                                          ref: allowZeroQuantitiesRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             (enablePurchaseOrder || enableSaleOrder)
                                                ? allowIncreaseQtyRef
                                                : (enablePurchaseChallan || enableSaleChallan)
                                                   ? allowChangePriceRef
                                                   : issuedaybookRef,
                                             allowEditLIAmountRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {enablePurchaseOrder || enableSaleOrder ? (
                                    <>
                                       {/* Show "Allow Increase Qty" only when ORDER is ON */}
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowIncreaseQty',
                                             'Allow Increase Qty',
                                             {
                                                isChecked: row.allowIncreaseQty,
                                                onChange: handleSwitchChange('allowIncreaseQty'),
                                                ref: allowIncreaseQtyRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   allowChangePriceRef,
                                                   allowZeroQuantitiesRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>

                                       {/* Show "Allow Change Price" when ORDER is ON */}
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowChangePrice',
                                             'Allow Change Price',
                                             {
                                                isChecked: row.allowChangePrice,
                                                onChange: handleSwitchChange('allowChangePrice'),
                                                ref: allowChangePriceRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   orderFieldRegionRef,
                                                   allowIncreaseQtyRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 ) : enablePurchaseChallan || enableSaleChallan ? (
                                    <>
                                       {/* Show only "Allow Change Price" when CHALLAN is ON */}
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowChangePrice',
                                             'Allow Change Price',
                                             {
                                                isChecked: row.allowChangePrice,
                                                onChange: handleSwitchChange('allowChangePrice'),
                                                ref: allowChangePriceRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   issuedaybookRef,
                                                   allowZeroQuantitiesRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 ) : null}
                                 {(enablePurchaseOrder || enableSaleOrder) && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {/* Header Done*/}
                                          {renderDynamicDropdown(
                                             'orderFieldRegion',
                                             'Order Field Region',
                                             OrderFieldRegion,
                                             {
                                                value: row.orderFieldRegion,
                                                onChange: (value) => handleInputChange('orderFieldRegion', value),
                                                ref: orderFieldRegionRef,
                                                isClearable: true,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   orderdaybookRef,
                                                   allowChangePriceRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Order Field Region',
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'orderdaybookid',
                                             'Order Daybook',
                                             // daybookList,
                                             daybookData.filter((item) => item.type === ((row.type === 4 || row.type === 5) ? 3 : 9)),
                                             {
                                                value: row.orderdaybookid,
                                                onChange: (value) => handleInputChange('orderdaybookid', value),
                                                showCustomNoOptions: true,
                                                openfrom: 'ledger',
                                                ref: orderdaybookRef,
                                                isClearable: true,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   issuedaybookRef,
                                                   orderFieldRegionRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Order Daybook',
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 {/* <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'issueFieldRegion',
                                       'Issue Field Region',
                                       OrderFieldRegion,
                                       {
                                          value: row.issueFieldRegion,
                                          onChange: (value) => handleInputChange('issueFieldRegion', value),
                                          ref: issueFieldRegionRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                issuedaybookRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Issue Field Region',
                                    )}
                                 </GridItem> */}
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'issuedaybookid',
                                       'Issue Daybook',
                                       daybookList,
                                       {
                                          value: row.issuedaybookid,
                                          onChange: (value) => handleInputChange('issuedaybookid', value),
                                          ref: issuedaybookRef,
                                          isClearable: true,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             (enableSaleChallan || enablePurchaseChallan)
                                                ? challanFieldRegionRef
                                                : Textile
                                                   ? getLineDetailRef
                                                   : methodOfRoundTRef,
                                             (enablePurchaseOrder || enableSaleOrder)
                                                ? orderdaybookRef
                                                : (enablePurchaseChallan || enableSaleChallan)
                                                   ? allowChangePriceRef
                                                   : allowZeroQuantitiesRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Issue Daybook',
                                    )}
                                 </GridItem>
                                 {(enableSaleChallan || enablePurchaseChallan) && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {/* Header */}
                                          {renderDynamicDropdown(
                                             'challanFieldRegion',
                                             'Challan Field Region',
                                             OrderFieldRegion,
                                             {
                                                value: row.challanFieldRegion,
                                                onChange: (value) => handleInputChange('challanFieldRegion', value),
                                                ref: challanFieldRegionRef,
                                                isClearable: true,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   challandaybookRef,
                                                   issuedaybookRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Challan Field Region',
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'challandaybookid',
                                             'Challan Daybook',
                                             // daybookList,
                                             daybookData.filter((item) => item.type === ((row.type === 4 || row.type === 5) ? 4 : 10)),
                                             {
                                                value: row.challandaybookid,
                                                onChange: (value) => handleInputChange('challandaybookid', value),
                                                ref: challandaybookRef,
                                                isClearable: true,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   Textile
                                                      ? getLineDetailRef
                                                      : methodOfRoundTRef,
                                                   challanFieldRegionRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Challan Daybook',
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 {Textile && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'getLineDetail',
                                             'Get Line Detail',
                                             {
                                                isChecked: row.getLineDetail,
                                                onChange: handleSwitchChange('getLineDetail'),
                                                ref: getLineDetailRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   challandaybookRef,
                                                   (enableSaleChallan || enablePurchaseChallan)
                                                      ? challandaybookRef
                                                      : issuedaybookRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>

                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'allowAutoIssue',
                                             'Allow Auto Issue',
                                             {
                                                isChecked: row.allowAutoIssue,
                                                onChange: handleSwitchChange('allowAutoIssue'),
                                                ref: allowAutoIssueRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   methodOfRoundTRef,
                                                   getLineDetailRef
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 {/* <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'shouldAskSendSMS',
                                       'Should Ask Send SMS',
                                       {
                                          isChecked: row.shouldAskSendSMS,
                                          onChange: handleSwitchChange('shouldAskSendSMS'),
                                          ref: shouldAskSendSMSRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                methodOfRoundTRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem> */}
                                 <GridItem className="seperator-width">
                                    {/* Normal Done */}
                                    {renderDynamicDropdown(
                                       'methodOfRoundT',
                                       'Round Off (T)',
                                       METHOD_OF_ROUND_LI_TYPE,
                                       {
                                          value: row.methodOfRoundT,
                                          onChange: (value) => handleInputChange('methodOfRoundT', value),
                                          ref: methodOfRoundTRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             methodOfRoundLIRef,
                                             Textile
                                                ? allowAutoIssueRef
                                                : (enableSaleChallan || enablePurchaseChallan)
                                                   ? challandaybookRef
                                                   : issuedaybookRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Method of Round T',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* None Done */}
                                    {renderDynamicDropdown(
                                       'methodOfRoundLI',
                                       'Round Off (LI)',
                                       METHOD_OF_ROUND_LI_TYPE,
                                       {
                                          value: row.methodOfRoundLI || METHOD_OF_ROUND_LI_TYPE[1].id,
                                          onChange: (value) => handleInputChange('methodOfRoundLI', value),
                                          ref: methodOfRoundLIRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             autoRoundOffAtRef,
                                             methodOfRoundTRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Method of Round LI',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* Total Done*/}
                                    {renderDynamicDropdown(
                                       'autoRoundOffAt',
                                       'Round off At',
                                       AUTO_ROUND_OFF_AT_TYPE,
                                       {
                                          value: row.autoRoundOffAt,
                                          onChange: (value) => handleInputChange('autoRoundOffAt', value),
                                          ref: autoRoundOffAtRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             requireDiscountLineItemRef,
                                             methodOfRoundLIRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Auto of Round T',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'requireDiscountLineItem',
                                       'Require Discount Line Item',
                                       {
                                          value: row.requireDiscountLineItem,
                                          onChange: (e) => handleInputChange('requireDiscountLineItem', e.target.value),
                                          ref: requireDiscountLineItemRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             mobile ? isAskToAllowRef : askPasswordOnDeleteRef,
                                             autoRoundOffAtRef
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       'number',
                                       false,
                                    )}
                                 </GridItem>
                                 {/* <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isNotConsiderInStock',
                                       'Is Not Consider In Stock',
                                       {
                                          isChecked: row.isNotConsiderInStock,
                                          onChange: handleSwitchChange('isNotConsiderInStock'),
                                          ref: isNotConsiderInStockRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                isAskToAllowRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem> */}
                                 {mobile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isAskToAllow',
                                          'Ask Upload Document',
                                          {
                                             isChecked: row.isAskToAllow,
                                             onChange: handleSwitchChange('isAskToAllow'),
                                             ref: isAskToAllowRef,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                askPasswordOnDeleteRef,
                                                requireDiscountLineItemRef
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'askPasswordOnDelete',
                                       'Ask Password On Delete',
                                       {
                                          isChecked: row.askPasswordOnDelete,
                                          onChange: handleSwitchChange('askPasswordOnDelete'),
                                          ref: askPasswordOnDeleteRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             isAskIncomeExpensesRef,
                                             mobile ? isAskToAllowRef : requireDiscountLineItemRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAskIncomeExpenses',
                                       'Ask Income Expenses',
                                       {
                                          isChecked: row.isAskIncomeExpenses,
                                          onChange: handleSwitchChange('isAskIncomeExpenses'),
                                          ref: isAskIncomeExpensesRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             dueDaysInputRef,
                                             askPasswordOnDeleteRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'dueDays',
                                       'dueDays',
                                       {
                                          value: row.dueDays,
                                          onChange: (e) => handleInputChange('dueDays', e.target.value),
                                          ref: dueDaysInputRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             prefixRef,
                                             isAskIncomeExpensesRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       'number',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'prefix',
                                       'prefix',
                                       {
                                          value: row.prefix,
                                          onChange: (e) => {
                                             const separatorObj = SAPRATER.find((item) => item.id === row.separator || item.value === row.separator);
                                             const sep = separatorObj ? separatorObj.name : '';
                                             let value = e.target.value;
                                             if (sep) {
                                                const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                                value = value.replace(new RegExp(escaped, 'g'), '');
                                             }
                                             handleInputChange('prefix', value);
                                          },
                                          ref: prefixRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             separatorRef,
                                             dueDaysInputRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'separator',
                                       'Separator',
                                       SAPRATER,
                                       {
                                          value: row.separator,
                                          onChange: (value) => handleInputChange('separator', value),
                                          ref: separatorRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             suffixRef,
                                             prefixRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Auto of Round T',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'suffix',
                                       'suffix',
                                       {
                                          value: row.suffix,
                                          onChange: (e) => {
                                             const separatorObj = SAPRATER.find((item) => item.id === row.separator || item.value === row.separator);
                                             const sep = separatorObj ? separatorObj.name : '';
                                             let value = e.target.value;
                                             if (sep) {
                                                const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                                value = value.replace(new RegExp(escaped, 'g'), '');
                                             }
                                             handleInputChange('suffix', value);
                                          },
                                          ref: suffixRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             savefinish,
                                             separatorRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                              </>
                           )}

                           {activeStep === 2 && (
                              <>
                                 {/* <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'titleMessage1',
                                       'Title Message 1',
                                       {
                                          value: row.titleMessage1,
                                          onChange: (e) => handleInputChange('titleMessage1', e.target.value),
                                          ref: titleMessage1Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                titleMessage2Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'titleMessage2',
                                       'Title Message 2',
                                       {
                                          value: row.titleMessage2,
                                          onChange: (e) => handleInputChange('titleMessage2', e.target.value),
                                          ref: titleMessage2Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                headerMessage1Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'headerMessage1',
                                       'Header Message 1',
                                       {
                                          value: row.headerMessage1,
                                          onChange: (e) => handleInputChange('headerMessage1', e.target.value),
                                          ref: headerMessage1Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                headerMessage2Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'headerMessage2',
                                       'Header Message 2',
                                       {
                                          value: row.headerMessage2,
                                          onChange: (e) => handleInputChange('headerMessage2', e.target.value),
                                          ref: headerMessage2Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                footerMessage1Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'footerMessage1',
                                       'Footer Message 1',
                                       {
                                          value: row.footerMessage1,
                                          onChange: (e) => handleInputChange('footerMessage1', e.target.value),
                                          ref: footerMessage1Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                footerMessage2Ref.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'footerMessage2',
                                       'Footer Message 2',
                                       {
                                          value: row.footerMessage2,
                                          onChange: (e) => handleInputChange('footerMessage2', e.target.value),
                                          ref: footerMessage2Ref,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                askBeforePrintRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem> */}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'askBeforePrint',
                                       'Ask Before Print',
                                       {
                                          isChecked: row.askBeforePrint,
                                          onChange: handleSwitchChange('askBeforePrint'),
                                          ref: askBeforePrintRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             onlinePrintingRef,
                                             null,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {/* <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'numOfCopies',
                                       'No. Of Copies',
                                       {
                                          value: row.numOfCopies || 1,
                                          onChange: (e) => handleInputChange('numOfCopies', e.target.value),
                                          ref: numOfCopiesRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                onlinePrintingRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'number',
                                       false,
                                    )}
                                 </GridItem> */}
                                 <GridItem className="seperator-width">
                                    {/* True */}
                                    {renderSwitchControl(
                                       'onlinePrinting',
                                       'Online Printing',
                                       {
                                          isChecked: row.onlinePrinting,
                                          onChange: handleSwitchChange('onlinePrinting'),
                                          ref: onlinePrintingRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             applyGST ? ewayBillRef : printingSettingsRef,
                                             askBeforePrintRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {applyGST && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'ewayBill',
                                             'E-way Bill',
                                             {
                                                isChecked: row.ewayBill,
                                                onChange: handleSwitchChange('ewayBill'),
                                                ref: ewayBillRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   ewayInvoiceRef,
                                                   onlinePrintingRef,
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'ewayInvoice',
                                             'E-Invoice',
                                             {
                                                isChecked: row.ewayInvoice,
                                                onChange: handleSwitchChange('ewayInvoice'),
                                                ref: ewayInvoiceRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   printingSettingsRef,
                                                   ewayBillRef,
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 <GridItem className="seperator-width">
                                    {/* Printing Settings Dropdown */}
                                    {renderDynamicDropdown(
                                       'printingSettings',
                                       'Printing Settings',
                                       PRINTING_SETTING_TYPE,
                                       {
                                          value: row.printingSettings,
                                          onChange: (value) => handleInputChange('printingSettings', value),
                                          ref: printingSettingsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             sendWhatsAppRef,
                                             applyGST ? ewayInvoiceRef : onlinePrintingRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Printing Settings',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'sendWhatsApp',
                                       'Send WhatsApp',
                                       {
                                          isChecked: row.sendWhatsApp,
                                          onChange: handleSwitchChange('sendWhatsApp'),
                                          ref: sendWhatsAppRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             wpSettingsRef,
                                             printingSettingsRef,
                                          ),
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* Printing Settings Dropdown */}
                                    {renderDynamicDropdown(
                                       'wpSettings',
                                       'WhatsApp Settings',
                                       PRINTING_SETTING_TYPE,
                                       {
                                          value: row.wpSettings,
                                          onChange: (value) => handleInputChange('wpSettings', value),
                                          ref: wpSettingsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             sendEmailRef,
                                             sendWhatsAppRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select WhatsApp Settings',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'sendEmail',
                                       'Send Email',
                                       {
                                          isChecked: row.sendEmail,
                                          onChange: handleSwitchChange('sendEmail'),
                                          ref: sendEmailRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             emailSettingsRef,
                                             wpSettingsRef,
                                          ),
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {/* Printing Settings Dropdown */}
                                    {renderDynamicDropdown(
                                       'emailSettings',
                                       'Email Settings',
                                       PRINTING_SETTING_TYPE,
                                       {
                                          value: row.emailSettings,
                                          onChange: (value) => handleInputChange('emailSettings', value),
                                          ref: emailSettingsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             accImgTermsRef,
                                             sendEmailRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Email Settings',
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderTextareaControl(
                                       'accImgTerms',
                                       'Account Image Terms',
                                       {
                                          value: row.accImgTerms,
                                          onChange: (e) => handleInputChange('accImgTerms', e.target.value),
                                          ref: accImgTermsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             accDocImgTermsRef,
                                             emailSettingsRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderTextareaControl(
                                       'accDocImgTerms',
                                       'Account Doc Image Terms',
                                       {
                                          value: row.accDocImgTerms,
                                          onChange: (e) => handleInputChange('accDocImgTerms', e.target.value),
                                          ref: accDocImgTermsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             termsNConditionsRef,
                                             accImgTermsRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderTextareaControl(
                                       'termsNConditions',
                                       'Terms and Conditions',
                                       {
                                          value: row.termsNConditions,
                                          onChange: (e) => handleInputChange('termsNConditions', e.target.value),
                                          ref: termsNConditionsRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             savefinish,
                                             accDocImgTermsRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                              </>
                           )}

                           {activeStep === 3 && (
                              <>
                                 {['Bank'].includes(row.typeName) && (
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'accountNo',
                                          'Account No.',
                                          {
                                             value: row.accountNo,
                                             onChange: (e) => handleInputChange('accountNo', e.target.value),
                                             ref: accountNoRef,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                savefinish,
                                                null,
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'shortName',
                                       'Short Name',
                                       {
                                          value: row.shortName,
                                          onChange: (e) => handleInputChange('shortName', e.target.value),
                                          ref: shortNameRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             printNameRef,
                                             ['Bank'].includes(row.typeName)
                                                ? accountNoRef
                                                : null,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'printName',
                                       'Print Name',
                                       {
                                          value: row.printName,
                                          onChange: (e) => handleInputChange('printName', e.target.value),
                                          ref: printNameRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             legalNameRef,
                                             shortNameRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'legalName',
                                       'Legal Name',
                                       {
                                          value: row.legalName,
                                          onChange: (e) => handleInputChange('legalName', e.target.value),
                                          ref: legalNameRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             updateRateInItemRef,
                                             printNameRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 {/* <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'notes',
                                       'Notes',
                                       {
                                          value: row.notes,
                                          onChange: (e) => handleInputChange('notes', e.target.value),
                                          ref: notesRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                remarksRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {DynamicInput(
                                       'remarks',
                                       'Remarks',
                                       {
                                          value: row.remarks,
                                          onChange: (e) => handleInputChange('remarks', e.target.value),
                                          ref: remarksRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                updateRateInItemRef.current?.focus();
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       'text',
                                       false,
                                    )}
                                 </GridItem> */}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'updateRateInItem',
                                       'Update Rate In Item',
                                       {
                                          isChecked: row.updateRateInItem,
                                          onChange: handleSwitchChange('updateRateInItem'),
                                          ref: updateRateInItemRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             itemWiseLastRateRef,
                                             legalNameRef,
                                          ),
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'itemWiseLastRate',
                                       'Item Wise Last Rate',
                                       {
                                          isChecked: row.itemWiseLastRate,
                                          onChange: handleSwitchChange('itemWiseLastRate'),
                                          ref: itemWiseLastRateRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             partyItemWiseLastRateRef,
                                             updateRateInItemRef,
                                          ),
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'partyItemWiseLastRate',
                                       'Party Item Wise Last Rate',
                                       {
                                          isChecked: row.partyItemWiseLastRate,

                                          onChange: handleSwitchChange('partyItemWiseLastRate'),
                                          ref: partyItemWiseLastRateRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             reverseCalcOnItemQtyRef,
                                             itemWiseLastRateRef,
                                          ),
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'reverseCalcOnItemQty',
                                       'Reverse Calc On Item Qty',
                                       {
                                          isChecked: row.reverseCalcOnItemQty,

                                          onChange: handleSwitchChange('reverseCalcOnItemQty'),
                                          ref: reverseCalcOnItemQtyRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             TDSApplyOnRef,
                                             partyItemWiseLastRateRef,
                                          ),
                                       },

                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'TDSApplyOn',
                                       'TDS Apply On',
                                       TDS_APPLY_ON,
                                       {
                                          value: row.TDSApplyOn,

                                          onChange: (value) => handleInputChange('TDSApplyOn', value),
                                          ref: TDSApplyOnRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             mobile
                                                ? isOldRef
                                                : (row.type === 5 || row.type === 19)
                                                   ? purcherDaybookRef
                                                   : row.type === 11
                                                      ? isGrayPurchaseRef
                                                      : row.type === 19
                                                         ? isMillIssueRef
                                                         : Textile
                                                            ? isOtherJobWorkRef
                                                            : isAllowNotesRef,
                                             reverseCalcOnItemQtyRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                    )}
                                 </GridItem>
                                 {/* <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'askOnlinePaymentDetails',
                                       'Ask Online Payment Details',
                                       {
                                          isChecked: row.askOnlinePaymentDetails,
                                          onChange: handleSwitchChange('askOnlinePaymentDetails'),
                                          ref: askOnlinePaymentDetailsRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (mobile) {
                                                   isOldRef.current?.focus();
                                                } else {
                                                   purcherDaybookRef.current?.focus();
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem> */}
                                 {mobile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isOld',
                                          'Is Old',
                                          {
                                             isChecked: row.isOld,
                                             onChange: handleSwitchChange('isOld'),
                                             ref: isOldRef,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                (row.type === 5 || row.type === 19)
                                                   ? purcherDaybookRef
                                                   : row.type === 11
                                                      ? isGrayPurchaseRef
                                                      : row.type === 19
                                                         ? isMillIssueRef
                                                         : Textile
                                                            ? isOtherJobWorkRef
                                                            : isAllowNotesRef,
                                                TDSApplyOnRef,
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {(row.type === 5 || row.type === 19) && (
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'purchaseDaybookId',
                                          'Purchase Daybook',
                                          // daybookData,
                                          daybookData.filter((item) => item.type === 11),
                                          {
                                             value: row.purchaseDaybookId,
                                             onChange: (value) => handleInputChange('purchaseDaybookId', value),
                                             ref: purcherDaybookRef,
                                             isClearable: true,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                row.type === 11
                                                   ? isGrayPurchaseRef
                                                   : row.type === 19
                                                      ? isMillIssueRef
                                                      : Textile
                                                         ? isOtherJobWorkRef
                                                         : isAllowNotesRef,
                                                mobile
                                                   ? isOldRef
                                                   : TDSApplyOnRef,
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {(row.type === 11 || row.type === 10) && (
                                    <>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'isGrayPurchase',
                                             'Is Gray Purchase',
                                             {
                                                isChecked: row.isGrayPurchase,
                                                onChange: handleSwitchChange('isGrayPurchase'),
                                                ref: isGrayPurchaseRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   isMillReceiveRef,
                                                   (row.type === 5 || row.type === 19)
                                                      ? purcherDaybookRef
                                                      : mobile
                                                         ? isOldRef
                                                         : TDSApplyOnRef,
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'isMillReceive',
                                             'Is Mill Receive',
                                             {
                                                isChecked: row.isMillReceive,
                                                onChange: handleSwitchChange('isMillReceive'),
                                                ref: isMillReceiveRef,
                                                onKeyDown: (e) => handleFocusMove(
                                                   e,
                                                   row.type === 19
                                                      ? isMillIssueRef
                                                      : Textile
                                                         ? isOtherJobWorkRef
                                                         : isAllowNotesRef,
                                                   isGrayPurchaseRef,
                                                ),
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             false,
                                          )}
                                       </GridItem>
                                    </>
                                 )}
                                 {row.type === 19 && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isMillIssue',
                                          'Is Mill Issue',
                                          {
                                             isChecked: row.isMillIssue,
                                             onChange: handleSwitchChange('isMillIssue'),
                                             ref: isMillIssueRef,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                Textile
                                                   ? isOtherJobWorkRef
                                                   : isAllowNotesRef,
                                                row.type === 11
                                                   ? isMillReceiveRef
                                                   : (row.type === 5 || row.type === 19)
                                                      ? purcherDaybookRef
                                                      : mobile
                                                         ? isOldRef
                                                         : TDSApplyOnRef,
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 {Textile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isOtherJobWork',
                                          'Is Other JobWork',
                                          {
                                             isChecked: row.isOtherJobWork,
                                             onChange: handleSwitchChange('isOtherJobWork'),
                                             ref: isOtherJobWorkRef,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                isAllowNotesRef,
                                                row.type === 19
                                                   ? isMillIssueRef
                                                   : row.type === 11
                                                      ? isMillReceiveRef
                                                      : (row.type === 5 || row.type === 19)
                                                         ? purcherDaybookRef
                                                         : mobile
                                                            ? isOldRef
                                                            : TDSApplyOnRef,
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAllowNotes',
                                       'Is Allow Notes',
                                       {
                                          isChecked: row.isAllowNotes,
                                          onChange: handleSwitchChange('isAllowNotes'),
                                          ref: isAllowNotesRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             isAllowRemarkRef,
                                             Textile
                                                ? isOtherJobWorkRef
                                                : row.type === 19
                                                   ? isMillIssueRef
                                                   : row.type === 11
                                                      ? isMillReceiveRef
                                                      : (row.type === 5 || row.type === 19)
                                                         ? purcherDaybookRef
                                                         : mobile
                                                            ? isOldRef
                                                            : TDSApplyOnRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 <GridItem className="seperator-width">
                                    {renderSwitchControl(
                                       'isAllowRemark',
                                       'Is Allow Remark',
                                       {
                                          isChecked: row.isAllowRemark,
                                          onChange: handleSwitchChange('isAllowRemark'),
                                          ref: isAllowRemarkRef,
                                          onKeyDown: (e) => handleFocusMove(
                                             e,
                                             textareaRef,
                                             isAllowNotesRef,
                                          ),
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       false,
                                    )}
                                 </GridItem>
                                 {Textile && (
                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isEnableItemScreen',
                                          'Enable Item Screen',
                                          {
                                             isChecked: row.isEnableItemScreen,
                                             onChange: handleSwitchChange('isEnableItemScreen'),
                                             ref: isEnableItemScreenRef,
                                             onKeyDown: (e) => handleFocusMove(
                                                e,
                                                isAllowNotesRef,
                                                row.type === 19
                                                   ? isMillIssueRef
                                                   : row.type === 11
                                                      ? isMillReceiveRef
                                                      : (row.type === 5 || row.type === 19)
                                                         ? purcherDaybookRef
                                                         : mobile
                                                            ? isOldRef
                                                            : TDSApplyOnRef,
                                             ),
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          false,
                                       )}
                                    </GridItem>
                                 )}
                                 <GridItem></GridItem>
                                 <div
                                    style={{
                                       width: '100%',
                                       gridColumn: '1 / -1',
                                       padding: '0',
                                       boxSizing: 'border-box',
                                    }}>
                                    <label
                                       style={{
                                          display: 'block',
                                          marginBottom: '12px',
                                          fontWeight: '600',
                                          fontSize: '16px',
                                          color: '#1f2937',
                                       }}>
                                       Custom Message Template
                                    </label>

                                    {/* Demo Formats Section - Working exactly like insert keys */}
                                    <div
                                       style={{
                                          marginBottom: '16px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          flexWrap: 'wrap',
                                          gap: '8px',
                                       }}>
                                       <span
                                          style={{
                                             fontWeight: '500',
                                             fontSize: '14px',
                                             color: '#6b7280',
                                             marginRight: '4px',
                                          }}>
                                          Demo Formats:
                                       </span>

                                       {/* Demo Format 1: Simple Receipt */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Your receipt #{docNo} for ₹{amount} has been processed on {txnDate}. Thank you!`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#dbeafe',
                                             border: '1px solid #93c5fd',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#1e40af',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#bfdbfe';
                                             e.currentTarget.style.borderColor = '#60a5fa';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#dbeafe';
                                             e.currentTarget.style.borderColor = '#93c5fd';
                                          }}
                                          title="Click to insert simple receipt format">
                                          Simple Receipt
                                       </button>

                                       {/* Demo Format 2: Detailed Transaction */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Transaction #{docNo}\nAmount: ₹{amount}\nDate: {txnDate}\nDaybook: {daybookName}\nCustomer: {customerName}\nNotes: {notes1}`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#dcfce7',
                                             border: '1px solid #86efac',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#166534',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#bbf7d0';
                                             e.currentTarget.style.borderColor = '#4ade80';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#dcfce7';
                                             e.currentTarget.style.borderColor = '#86efac';
                                          }}
                                          title="Click to insert detailed transaction format">
                                          Detailed Format
                                       </button>

                                       {/* Demo Format 3: Invoice Style */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Invoice #{docNo}\nCustomer: {customerName}\nCompany: {companyName}\nNet Amount: ₹{netAmount}\nGST: ₹{gstAmount}\nDate: {txnDate}`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#fef3c7',
                                             border: '1px solid #fcd34d',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#92400e',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fde68a';
                                             e.currentTarget.style.borderColor = '#fbbf24';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fef3c7';
                                             e.currentTarget.style.borderColor = '#fcd34d';
                                          }}
                                          title="Click to insert invoice format">
                                          Invoice Style
                                       </button>

                                       {/* Demo Format 4: Short SMS Style */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Hi {customerName}, your txn #{docNo} of ₹{amount} is completed on {txnDate}.`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#ede9fe',
                                             border: '1px solid #a78bfa',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#5b21b6',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#ddd6fe';
                                             e.currentTarget.style.borderColor = '#8b5cf6';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#ede9fe';
                                             e.currentTarget.style.borderColor = '#a78bfa';
                                          }}
                                          title="Click to insert SMS style format">
                                          SMS Style
                                       </button>

                                       {/* Demo Format 5: Professional Format */}
                                       <button
                                          type="button"
                                          onClick={() =>
                                             insertDemoFormat(
                                                `Dear {customerName},\n\nThis is to confirm that your transaction #{docNo} for ₹{amount} has been successfully processed through {daybookName} on {txnDate}.\n\nThank you for your business.\n\nBest regards,\n{companyName}`,
                                             )
                                          }
                                          style={{
                                             padding: '8px 14px',
                                             backgroundColor: '#fce7f3',
                                             border: '1px solid #f9a8d4',
                                             borderRadius: '6px',
                                             cursor: 'pointer',
                                             fontSize: '13px',
                                             fontWeight: '500',
                                             color: '#9d174d',
                                             transition: 'all 0.2s',
                                             flexShrink: 0,
                                          }}
                                          onMouseEnter={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fbcfe8';
                                             e.currentTarget.style.borderColor = '#f472b6';
                                          }}
                                          onMouseLeave={(e) => {
                                             e.currentTarget.style.backgroundColor = '#fce7f3';
                                             e.currentTarget.style.borderColor = '#f9a8d4';
                                          }}
                                          title="Click to insert professional format">
                                          Professional
                                       </button>
                                    </div>

                                    {/* Insert Keys Section */}
                                    <div
                                       style={{
                                          marginBottom: '16px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          flexWrap: 'wrap',
                                          gap: '8px',
                                       }}>
                                       <span
                                          style={{
                                             fontWeight: '500',
                                             fontSize: '14px',
                                             color: '#6b7280',
                                             marginRight: '4px',
                                          }}>
                                          Insert keys:
                                       </span>

                                       {(() => {
                                          // Get the current selected type from various possible sources
                                          const currentType = type || row?.type;
                                          const currentTypeName = row?.typeName;

                                          // Check if it's Cash or Bank
                                          const isCashOrBank = () => {
                                             // Check by code
                                             if (currentType === 'M' || currentType === 'N') return true;

                                             // Check by name
                                             if (currentTypeName === 'Cash' || currentTypeName === 'Bank') return true;

                                             // Check in TYPE array
                                             if (TYPE && currentType) {
                                                const typeItem = TYPE.find(
                                                   (item) =>
                                                      item.id === currentType ||
                                                      item.value === currentType ||
                                                      item.name === currentTypeName,
                                                );
                                                if (typeItem && (typeItem.code === 'M' || typeItem.code === 'N')) {
                                                   return true;
                                                }
                                             }

                                             return false;
                                          };

                                          const cashBankKeys = [
                                             'docNo',
                                             'amount',
                                             'daybookName',
                                             'txnDate',
                                             'chequeNo',
                                             'notes1',
                                             'notes2',
                                             'notes3',
                                             'notes4',
                                             'notes5',
                                             'customerName',
                                             'companyName',
                                             'gstAmount',
                                             'partyBillNo',
                                             'balance'
                                          ];

                                          const otherKeys = [
                                             'lrNo',
                                             'lrDate',
                                             'docNo',
                                             'notes',
                                             'partyNo',
                                             'customerName',
                                             'companyName',
                                             'daybookName',
                                             'gstAmount',
                                             'netAmount',
                                             'partyDate',
                                             'transportName',
                                             'vehicleName',
                                             'ewayBillNo',
                                             'ewayBillDate',
                                             'eInvoiceNo',
                                             'taxableAmount',
                                             'txnDate',
                                             'pendingAmt',
                                             'imeiNo'
                                          ];

                                          const keysToShow = isCashOrBank() ? cashBankKeys : otherKeys;

                                          return keysToShow.map((key) => (
                                             <button
                                                key={key}
                                                type="button"
                                                onClick={() => insertKeyIntoMessage(key)}
                                                style={{
                                                   padding: '8px 14px',
                                                   backgroundColor: '#f3f4f6',
                                                   border: '1px solid #d1d5db',
                                                   borderRadius: '6px',
                                                   cursor: 'pointer',
                                                   fontSize: '13px',
                                                   fontWeight: '500',
                                                   color: '#374151',
                                                   transition: 'all 0.2s',
                                                   flexShrink: 0,
                                                }}
                                                onMouseEnter={(e) => {
                                                   e.currentTarget.style.backgroundColor = '#e5e7eb';
                                                   e.currentTarget.style.borderColor = '#9ca3af';
                                                }}
                                                onMouseLeave={(e) => {
                                                   e.currentTarget.style.backgroundColor = '#f3f4f6';
                                                   e.currentTarget.style.borderColor = '#d1d5db';
                                                }}>
                                                {key}
                                             </button>
                                          ));
                                       })()}
                                    </div>

                                    <div style={{ width: '100%' }}>
                                       {/* Highlighted backdrop */}
                                       {/* <div
                                          ref={highlightRef}
                                          style={{
                                             position: 'absolute',
                                             top: 0,
                                             left: 0,
                                             right: 0,
                                             bottom: 0,
                                             padding: '14px',
                                             fontSize: '14px',
                                             lineHeight: '1.6',
                                             fontFamily:
                                                'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                                             whiteSpace: 'pre-wrap',
                                             wordBreak: 'break-word',
                                             overflowWrap: 'break-word',
                                             color: '#1f2937',
                                             backgroundColor: 'transparent',
                                             border: '2px solid transparent',
                                             borderRadius: '8px',
                                             boxSizing: 'border-box',
                                             pointerEvents: 'none',
                                          }}>
                                          {row.customTemp ? (
                                             renderColoredText(row.customTemp)
                                          ) : (
                                             <span style={{ color: '#9ca3af' }}>
                                                Type your message here. Click keys above to insert variables like{' '}
                                                {'{docNo}'}, {'{amount}'}
                                             </span>
                                          )}
                                       </div> */}

                                       <textarea
                                          ref={textareaRef}
                                          value={row.customTemp || ''}
                                          onChange={handleCustomTempChange}
                                          onKeyDown={(e) => {
                                             if (e.key === 'Enter') {
                                                e.stopPropagation();
                                                return;
                                             }
                                             handleFocusMove(e, savefinish, isAllowRemarkRef);
                                          }}
                                          onFocus={(e) => e.target.style.border = '2px solid #3b82f6'}
                                          onBlur={(e) => e.target.style.border = `2px solid ${errors.customTemp ? '#ef4444' : '#d1d5db'}`}
                                          placeholder="Type your message here. Click keys above to insert variables like {docNo}, {amount}"
                                          spellCheck={false}
                                          style={{
                                             width: '100%',
                                             minHeight: '200px',
                                             maxHeight: '400px',
                                             padding: '14px',
                                             border: `2px solid ${errors.customTemp ? '#ef4444' : '#d1d5db'}`,
                                             borderRadius: '8px',
                                             fontSize: '14px',
                                             lineHeight: '1.6',
                                             fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                                             resize: 'vertical',
                                             boxSizing: 'border-box',
                                             outline: 'none',
                                             color: '#1f2937',
                                             backgroundColor: '#ffffff',
                                             overflowY: 'auto',
                                          }}
                                       />
                                    </div>
                                    {errors.customTemp && (
                                       <div
                                          style={{
                                             color: '#ef4444',
                                             fontSize: '13px',
                                             marginTop: '10px',
                                             padding: '8px 12px',
                                             backgroundColor: '#fef2f2',
                                             border: '1px solid #fecaca',
                                             borderRadius: '6px',
                                          }}>
                                          {errors.customTemp}
                                       </div>
                                    )}
                                    {error && (
                                       <div
                                          style={{
                                             color: '#ef4444',
                                             fontSize: '13px',
                                             marginTop: '10px',
                                             padding: '8px 12px',
                                             backgroundColor: '#fef2f2',
                                             border: '1px solid #fecaca',
                                             borderRadius: '6px',
                                          }}>
                                          {error}
                                       </div>
                                    )}
                                 </div>
                              </>
                           )}
                        </Grid>
                     </Box>
                  </GridItem>
               </Grid>
            </ModalBody>

            <ModalFooter
               borderTop="1px solid"
               borderColor={isDark ? 'gray.700' : 'gray.200'}
               bg={isDark ? 'gray.900' : 'gray.50'}
               borderBottomRadius="24px"
               p={2}
               gap={3}>
               {activeStep > 0 && (
                  <Button
                     onClick={handlePrevious}
                     variant="ghost"
                     colorScheme="purple"
                     size="lg"
                     fontWeight="600"
                     _hover={{ bg: isDark ? 'purple.900' : 'purple.50' }}
                     _focus={{ boxShadow: '0 0 0 3px rgba(139, 92, 246, 0.3)' }}>
                     Previous
                  </Button>
               )}
               {activeStep < 3 && (
                  <Button
                     onClick={handleNext}
                     variant="ghost"
                     colorScheme="purple"
                     size="lg"
                     fontWeight="600"
                     _hover={{ bg: isDark ? 'purple.900' : 'purple.50' }}
                     _focus={{ boxShadow: '0 0 0 3px rgba(139, 92, 246, 0.3)' }}>
                     Next
                  </Button>
               )}

               {!isEditMode && saveandcontinue === true && (
                  <Button
                     onClick={handlesavecontinue}
                     isLoading={isLoading}
                     disabled={isLoading}
                     bg={isDark ? 'blue.600' : 'blue.500'}
                     color="white"
                     size="lg"
                     fontWeight="600"
                     _hover={{ bg: isDark ? 'blue.700' : 'blue.600' }}
                     _active={{ bg: isDark ? 'blue.800' : 'blue.700' }}
                     _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.3)' }}
                     boxShadow="0 4px 12px rgba(59, 130, 246, 0.3)">
                     Save & Continue
                  </Button>
               )}
               <Button
                  onClick={handleSave}
                  isLoading={isLoading}
                  disabled={isLoading}
                  ref={savefinish}
                  bg={
                     isDark
                        ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                        : 'linear-gradient(135deg, #34d399 0%, #10b981 100%)'
                  }
                  color="white"
                  size="lg"
                  fontWeight="600"
                  _hover={{
                     transform: 'translateY(-2px)',
                     boxShadow: '0 8px 20px rgba(16, 185, 129, 0.4)',
                  }}
                  _active={{ transform: 'translateY(0)' }}
                  _focus={{ boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.3)' }}
                  boxShadow="0 4px 12px rgba(16, 185, 129, 0.3)"
                  transition="all 0.3s">
                  Save & Finish
               </Button>

               <Button
                  variant="ghost"
                  onClick={handleCansel}
                  size="lg"
                  fontWeight="600"
                  color={isDark ? 'gray.400' : 'gray.600'}
                  _hover={{ bg: isDark ? 'gray.800' : 'gray.100' }}
                  _focus={{ boxShadow: '0 0 0 3px rgba(107, 114, 128, 0.3)' }}>
                  Cancel
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default DaybookForm;
